import { render } from "./NieuwsDialog.vue?vue&type=template&id=c0753512&scoped=true"
import script from "./NieuwsDialog.vue?vue&type=script&lang=js"
export * from "./NieuwsDialog.vue?vue&type=script&lang=js"

import "./NieuwsDialog.vue?vue&type=style&index=0&id=c0753512&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0753512"]])

export default __exports__